import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const wsBase = () =>
  `${BACKEND_URL.replace("https://", "wss://").replace("http://", "ws://")}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// the backend's answer while updated terms wait (backend/legal.py TERMS_REQUIRED): the app shows the terms page
export const TERMS_REQUIRED = "Accept the updated Terms of Service and Privacy Policy to continue.";
let onTermsRequired = null;
export const whenTermsRequired = (fn) => { onTermsRequired = fn; };
api.interceptors.response.use((r) => r, (error) => {
  if (error?.response?.status === 403 && error.response.data?.detail === TERMS_REQUIRED) onTermsRequired?.();
  return Promise.reject(error);
});

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
